import styles from "./StaffSelector.module.scss";
import { useState, useRef, useEffect } from "react";
import useMobile from "../../hooks/useMobile";
import { VscChevronDown } from "react-icons/vsc";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import { motion, AnimatePresence } from "framer-motion";
import "swiper/css";
import "swiper/css/free-mode";

const StaffSelector = (props) => {
  const isMobile = useMobile();
  const [selectedItem, setSelectedItem] = useState(
    props.selectedItem
      ? props.selectedItem
      : props.items[props.defaultValueIndex]
  );
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [positionTop, setPositionTop] = useState(false);
  const [heightofPopup, setHeightofPopup] = useState();
  const [delay, setDelay] = useState(false);
  const componentRef = useRef(null);
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        componentRef.current &&
        !componentRef.current.contains(event.target) &&
        !event.target.hasAttribute("isitem")
      ) {
        setDelay(true);
      }
    };

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Unbind the event listener on cleanup
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("scrollend", popupPositioning);
    return () => {
      // Unbind the event listener on cleanup
      window.removeEventListener("scrollend", popupPositioning);
    };
  }, []);

  useEffect(() => {
    popupPositioning();
  }, [isPopupVisible]);

  const popupPositioning = () => {
    if (componentRef.current && popupRef.current) {
      const popuprectHeight = popupRef.current.offsetHeight;
      setHeightofPopup(popuprectHeight);
      const rect = componentRef.current.getBoundingClientRect();
      const bottomSpace = window.innerHeight - rect.bottom - popuprectHeight;
      if (bottomSpace < 120) {
        setPositionTop(true);
      } else {
        setPositionTop(false);
      }
    }
  };

  useEffect(() => {
    if (isPopupVisible && delay) {
      setTimeout(() => {
        setIsPopupVisible(() => false);
        setDelay(() => false);
      }, 300);
    }
  }, [delay]);

  const handleItemSelect = (item) => {
    setSelectedItem(item);
    setIsPopupVisible(false);
    props.onChange(item);
  };

  const handleInputClick = () => {
    setIsPopupVisible(!isPopupVisible);
    if (!isPopupVisible) {
      setDelay(false);
    }
  };

  const drawInput = () => {
    return (
      <div className={styles["input"]} onClick={handleInputClick}>
        <div className={styles["item-label"]}>{selectedItem.label}</div>
        <div className={styles["item-label2"]}>{selectedItem.label2}</div>
        <VscChevronDown
          color="#222222"
          size="25"
          className={styles["item-arrow-down"]}
          style={isPopupVisible ? { transform: "rotate(180deg)" } : {}}
        />
      </div>
    );
  };

  const drawItem = (item, index) => {
    // eslint-disable-next-line
    if (item.id_employee !== selectedItem.id_employee) {
      return (
        <div
          key={index}
          isitem="yes"
          className={styles["item"]}
          onClick={() => {
            handleItemSelect(item);
          }}
        >
          {item.iconJsx}

          <div className={styles["item-label"]} isitem="yes">
            {item.label}
          </div>
          <div className={styles["item-label2"]} isitem="yes">
            {item.label2}
          </div>
          <div className={styles["item-place-holder-right"]} isitem="yes">
            &nbsp;
          </div>
        </div>
      );
    }
  };

  return (
    <div className={styles["container"]} style={{ overflowX: "visible" }}>
      {!isMobile ? (
        <>
          <div className={styles["input"]} ref={componentRef}>
            {drawInput()}
          </div>
          {isPopupVisible && (
            <AnimatePresence>
              <motion.div
                initial={{ opacity: !delay ? 0 : 1 }}
                animate={{ opacity: !delay ? 1 : 0 }}
                transition={{ duration: 0.2 }}
              >
                <div
                  className={styles["popup"]}
                  ref={popupRef}
                  style={{
                    top: positionTop ? `-${heightofPopup + 6}px` : 39,
                  }}
                >
                  {props.items.map(drawItem)}
                </div>
              </motion.div>
            </AnimatePresence>
          )}
        </>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            overflow: "visible",
          }}
          className={styles["mobile-main"]}
        >
          <Swiper
            slidesPerView="auto"
            spaceBetween={10}
            style={{
              width: "100%",
              padding: "0 10px",
            }}
            slidesOffsetAfter={80}
            freeMode={true}
            modules={[FreeMode]}
          >
            {props.items.map((item, index) => {
              // Find the index of the first space
              const firstSpaceIndex = item?.label?.indexOf(" ");
              // Find the index of the second space starting from the index of the first space + 1
              const secondSpaceIndex = item?.label?.indexOf(
                " ",
                firstSpaceIndex + 1
              );
              return (
                <SwiperSlide
                  style={{
                    width: "auto",
                    maxWidth: "100px",
                  }}
                  key={item.id_employee}
                  onClick={() => handleItemSelect(item)}
                >
                  <div
                    className={styles["mobile-main-box"]}
                    aria-selected={
                      item.id_employee === selectedItem.id_employee
                    }
                  >
                    <div className={styles["mobile-item-icon"]}>
                      {item.iconJsx}
                    </div>
                    {/* In mobile, we are showing all salom operators first name but "best available"
                      have 2 letters, we are dealing this in below line.
                    */}
                    {item.label && (
                      <div
                        style={{
                          textWrap: "wrap",
                        }}
                        className={styles["item-label"]}
                      >
                        {item.label.includes("Il")
                          ? item.label.substring(0, secondSpaceIndex)
                          : item.label.substring(0, item.label.indexOf(" "))}
                      </div>
                    )}
                    {item.label2 && (
                      <div className={styles["item-label2"]}>{item.label2}</div>
                    )}
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      )}
    </div>
  );
};

export default StaffSelector;
